
<!-- If you don't use Pug in your project-->
<!-- click View Compiled HTML inside top/right HTML editor dropdown-->
<div class="overlay" *ngIf="_loader">
    <svg class="loader center" viewBox="0 0 384 384" xmlns="http://www.w3.org/2000/svg">
      <circle class="active" pathLength="360" fill="transparent" stroke-width="50" cx="192" cy="192" r="176"></circle>
      <circle class="track" pathLength="360" fill="transparent" stroke-width="50" cx="192" cy="192" r="176"></circle>
    </svg>
  </div>